import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import {
  getAuthorizedUser,
  storeAuthorizedUser,
} from 'app/services/LocalStorage'

import { AppDispatch } from 'app/store'
import { updateAuthStatusThunk } from '../login/slice'
import { getUserInfo, updateUser } from './api'
import { MyAccountFormValues } from './types'

const activeUserInfoSlice = makeFetchSlice('activeUserInfo')
export const activeUserInfoReducer = activeUserInfoSlice.reducer
export const activeUserInfoActions = activeUserInfoSlice.actions

export const getActiveUserInfoThunk = () => {
  return async (dispatch: AppDispatch) => {
    try {
      const storedUser = getAuthorizedUser()

      if (storedUser) {
        const payload = await fetchEdgeDataThunk({
          dispatch,
          actions: activeUserInfoActions,
          asyncFunc: () => getUserInfo(storedUser.userId),
        })
        await storeAuthorizedUser({ ...storedUser, ...payload })
        await dispatch(updateAuthStatusThunk())
        return payload
      }
    } catch (err) {
      console.log('Error while getting active user info attempt:' + err)
      dispatch(activeUserInfoActions.failure(err))
    }
  }
}

const requestUserUpdateSlice = makeFetchSlice('requestUserUpdate')
export const requestUserUpdateReducer = requestUserUpdateSlice.reducer
export const requestUserUpdateActions = requestUserUpdateSlice.actions

export const requestUserUpdateThunk = (params: MyAccountFormValues) => {
  return async (dispatch: AppDispatch) => {
    try {
      const storedUser = getAuthorizedUser()

      if (storedUser) {
        const payload = await fetchEdgeDataThunk({
          dispatch,
          actions: requestUserUpdateActions,
          asyncFunc: () => updateUser(storedUser.userId, params),
        })
        await dispatch(getActiveUserInfoThunk())
        return payload
      }
    } catch (err) {
      console.log('Error while updating user attempt:' + err)
      dispatch(requestUserUpdateActions.failure(err))
    }
  }
}
